import src from "IMAGE";
export default { src, width: 106, height: 28, blurWidth: 0, blurHeight: 0};
